import React, { type FunctionComponent, useEffect, useMemo } from 'react'
import { css } from '@emotion/react'
import { SimpleSelect, spacing, useDebouncedState } from '@retailer-platform/shared-components'
import { useDomainMessages } from 'domains/collections/utils/domain/intl'
import { Input } from 'gin-and-tonic/common/input/Input'

interface CollectionsListFiltersProps {
  filterParams: {
    collectionName: string
    status: string
  }
  setCollectionName: (collectionName: string) => void
  setStatus: (status: string) => void
  retailerId?: string
}

const filtersWrapper = css({
  display: 'flex',
  alignItems: 'center',
})

const searchWrapper = css({
  width: 320,
  margin: 0,
  padding: 0,
  marginRight: spacing.X16,
})

const searchStyles = css({
  height: 32,
})

const selectWrapper = css({
  width: 200,
  marginRight: spacing.X16,
})

export const CollectionsListFilters: FunctionComponent<CollectionsListFiltersProps> = ({
  filterParams,
  setCollectionName,
  setStatus,
}) => {
  const [internalCollectionName, debouncedInternalCollectionName, setInternalCollectionName] =
    useDebouncedState(filterParams.collectionName, 500)

  useEffect(() => {
    setCollectionName(debouncedInternalCollectionName)
  }, [setCollectionName, debouncedInternalCollectionName])

  const messages = useDomainMessages({
    default: 'collectionsDomain.list.status.default',
    active: 'collectionsDomain.list.status.active',
    inactive: 'collectionsDomain.list.status.inactive',
    search: 'collectionsDomain.list.filters.search',
  })

  const statusOptions: { label: string; value: string }[] = useMemo(
    () => [
      {
        label: messages.default,
        value: undefined,
      },
      {
        label: messages.active,
        value: 'active',
      },
      {
        label: messages.inactive,
        value: 'inactive',
      },
    ],
    [messages]
  )

  return (
    <div css={filtersWrapper}>
      <Input
        name="search"
        placeholder={messages.search}
        outerStyles={searchWrapper}
        styles={searchStyles}
        value={internalCollectionName ?? ''}
        onChange={e => setInternalCollectionName(e.target.value)}
      />

      <div css={selectWrapper}>
        <SimpleSelect onChange={setStatus} value={filterParams.status} options={statusOptions} />
      </div>
    </div>
  )
}
